import React, { useContext, useEffect } from "react";
import ViewSupportTicketDetailsComponent from "../components/tickets/ViewSupportTicketDetails";
import TitleContext from "../context/TitleContext";

export default function TicketDetailsPage() {
  const { setTitle } = useContext(TitleContext);
  useEffect(() => {
    setTitle("Complaint Details");
  }, [setTitle]);
  return <ViewSupportTicketDetailsComponent />;
}
